import { UserRankingItem } from "../UserRankingItem";
import { Container } from "./styles";

import { UserRankingCardProps } from "./types";

export function UsersRankingCard({ title, data }: UserRankingCardProps) {
  return (
    <Container>
      {title && <strong>{title}</strong>}

      {data.map((user) => (
        <UserRankingItem
          key={user.id}
          name={user.full_name}
          photo={user.image}
          usage={user.usage}
        />
      ))}
    </Container>
  );
}
